import axios from '@/libs/axios'

const API_BASE_URL = '/cursos'

export default {
  // Obtener todos los cursos
  async getAll() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching courses:', error)
      throw error
    }
  },

  // Obtener cursos activos (el endpoint principal ya filtra por estado activo)
  async getActive() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching active courses:', error)
      throw error
    }
  },

  // Obtener un curso por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching course:', error)
      throw error
    }
  },

  // Obtener cursos por carrera
  async getByCarrera(carreraId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/by-carrera/${carreraId}`)
      return response.data
    } catch (error) {
      console.error('Error fetching courses by carrera:', error)
      throw error
    }
  },

  // Crear un nuevo curso
  async create(courseData) {
    try {
      const response = await axios.post(API_BASE_URL, courseData)
      return response.data
    } catch (error) {
      console.error('Error creating course:', error)
      throw error
    }
  },

  // Actualizar un curso
  async update(id, courseData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, courseData)
      return response.data
    } catch (error) {
      console.error('Error updating course:', error)
      throw error
    }
  },

  // Eliminar un curso
  async delete(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting course:', error)
      throw error
    }
  }
}